import { useContext } from "react";
import {
  PlanContext,
  PlanProviderContext,
} from "domains/teams/contexts/PlanProvider";

export function usePlanContext() {
  return useContext<PlanProviderContext>(PlanContext);
}
